import * as types from './constants';

export function setSupportedCountries(supportedCountries) {
  return { type: types.SET_SUPPORTED_COUNTRIES, supportedCountries };
}
